import apiClient from "../core/HttpClient";
import { DietaryPreference } from "../models";

export default class DietaryPreferenceService{
    url="/DietaryPreferences";

    public async getDietaryPreferences(): Promise<DietaryPreference[]> {
        return await apiClient.get(this.url).then((res) => res.data);
    }

    public async getDietaryPreferenceById(id: string): Promise<DietaryPreference> {
        return await apiClient.get(`${this.url}/${id}`).then((res) => res.data);
    }

    public async createDietaryPreference(dietaryPreference: DietaryPreference) {
        return await apiClient.post(this.url, dietaryPreference);
    }

    public async updateDietaryPreference(dietaryPreference: DietaryPreference) {
        return await apiClient.put(`${this.url}`, dietaryPreference);
    }

    public async deleteDietaryPreference(id: number) {
        return await apiClient.delete(`${this.url}/${id}`);
    }
}
